<template>
  <div class="step1-wrapper" v-if="application">
    <ValidationObserver v-slot="{ handleSubmit, invalid, dirty }" ref="applicantForm">
      <form class="uk-form" @submit.prevent="handleSubmit(create)" autocomplete="chrome-off">
        <template v-if="!userIsStudent">
          <div v-if="application.jobs_data" class="parent-guardian-wrapper uk-padding-top uk-margin-bottom-large">
            <validated-section :errors="errors" field="applicant_type">
              <div class="uk-display-inline">
              <span><label class="custom" for="base-radio" style="padding-right: 15px">{{ __('global.i_am_a') }} <span
                  class="uk-visible-small">:</span></label>
                <hr class="uk-visible-small"> <input type="radio" id="renter-radio" name="parent-guardian-radio"
                                                     :value="1" v-model="application.jobs_data.applicant_type">
                <label class="custom use-hand-cursor" for="renter-radio">{{ __('global.parent') }}</label>
              </span>
              </div>
              <div class="uk-display-inline uk-margin-left">
                <br class="uk-visible-small"><input type="radio" id="homeowner-radio" name="parent-guardian-radio"
                                                    :value="2" v-model="application.jobs_data.applicant_type">
                <label class="custom use-hand-cursor" for="homeowner-radio">{{ __('global.legal_guardian') }}</label>
              </div>
            </validated-section>
          </div>
        </template>
        <fieldset class="uk-margin-top">
          <template v-if="!userIsStudent">
            <legend class="">{{ __('tenant.parent_or_legal_guardian') }}</legend>
            <div class="uk-container">
              <div class="uk-grid">
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <TextInput v-model="applicant.first_name" :name="__('tenant.first_name')"
                             :placeholder="__('tenant.first_name')" rules="required" :label="__('tenant.first_name')"/>
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <TextInput v-model="applicant.last_name" :name="__('tenant.last_name')"
                             :placeholder="__('tenant.last_name')" rules="required" :label="__('tenant.last_name')"/>
                </div>
                <ul v-if="usingScreenReader" aria-label="How to use datePicker" class="uk-width-1-1">
                  <li>Use Arrow Keys to navigate between days.</li>
                  <li>previous year: Control + Command + Arrow Up</li>
                  <li>Next year: Control + Command + Arrow Down</li>
                  <li>previous month: Control + Command + Arrow Left</li>
                  <li>Next month: Control + Command + Arrow Right</li>
                  <li>Select Date: Enter</li>
                </ul>
                <div class="uk-width-medium-1-4 uk-margin-bottom">
                  <date-picker :name="__('tenant.birth_date')" :label="__('tenant.birth_date')" v-model="applicant.dob"
                               :config="applicantDatePickerConfig" :placeholder="__('tenant.birth_date')"
                               rules="required"/>
                  <a
                      uk-tooltip title="HOW TO ENTER YOUR BIRTHDATE"
                      onclick="UIkit.modal.alert('<div class=\'uk-grid\'><div class=\'uk-width-1-1 uk-margin-bottom\'><h1>How to Use the Calendar Field</h1></div><div class=\'uk-width-1-2\'><h3><strong>How to enter your birth date: <ul><li>Click on the field to open the calendar.</li><li>Click on the month to select your birth month.</li><li>Double click on the year to select it, and type in your birth year.</li><li>Click on your birth day</li><li>The calendar modal will close automatically.</li></ul></h3></div><div class=\'uk-width-1-2\'><img src=\'/images/calendar-how-to.gif\'></div></div>');"
                      class="uk-dark uk-light use-hand-cursor theme-primary-bg-color"
                      style="position: relative; top: -55px; float: right; margin-right: 5.85px; padding: 0px; font-size: 14px; background-color: #6495d1; width: 20px; height: 20px; display: block; border-radius: 10px; text-align: center; color:white">?</a>
                </div>
                <ul v-if="usingScreenReader" aria-label="Explanation from the HUD Race" class="uk-width-1-1">
                  <li>American Indian or Alaska Native: A person having origins in any of the original peoples of North
                    and South America (including Central America), and who maintains tribal affiliation or community
                    attachment.
                  </li>
                  <li>Asian: A person having origins in any of the original peoples of the Far East, Southeast Asia, or
                    the Indian subcontinent including, for example, Cambodia, China, India, Japan, Korea, Malaysia,
                    Pakistan, the Philippine Islands, Thailand, and Vietnam.
                  </li>
                  <li>Black or African American: A person having origins in any of the black racial groups of Africa.
                    Terms such as “Haitian” can be used in addition to “Black” or “African American.”
                  </li>
                  <li>Native Hawaiian or Other Pacific Islander: A person having origins in any of the original peoples
                    of
                    Hawaii, Guam, Samoa, or other Pacific Islands.
                  </li>
                  <li>White: A person having origins in any of the original peoples of Europe, the Middle East or North
                    Africa.
                  </li>
                </ul>
                <div class="uk-width-medium-1-4 uk-margin-bottom">
                  <label>{{ __('tenant.race') }}: <a uk-tooltip title="EXPLANATION FROM THE HUD RACE"
                                                     onclick="UIkit.modal.alert('<div class=\'uk-grid\'><div class=\'uk-width-1-1 uk-margin-bottom\'><h1>Explanation from the HUD Race</h1></div><div class=\'uk-width-1-1\'><ul><li><strong>American Indian or Alaska Native: </strong>A person having origins in any of the original peoples of North and South America (including Central America), and who maintains tribal affiliation or community attachment.</li><li><strong>Asian: </strong>A person having origins in any of the original peoples of the Far East, Southeast Asia, or the Indian subcontinent including, for example, Cambodia, China, India, Japan, Korea, Malaysia, Pakistan, the Philippine Islands, Thailand, and Vietnam.</li><li><strong>Black or African American: </strong>A person having origins in any of the black racial groups of Africa. Terms such as “Haitian” can be used in addition to “Black” or “African American.” </li> <li><strong>Native Hawaiian or Other Pacific Islander: </strong>A person having origins in any of the original peoples of Hawaii, Guam, Samoa, or other Pacific Islands. </li> <li><strong>White: </strong>A person having origins in any of the original peoples of Europe, the Middle East or North Africa. </li> </ul></div></div>');"
                                                     class="uk-dark uk-light use-hand-cursor theme-primary-bg-color"
                                                     style="top: -55px; float: right; margin-right: 5.85px; padding: 0px; font-size: 14px; background-color: #6495d1; width: 20px; height: 20px; display: block; border-radius: 10px; text-align: center; color:white">?</a></label>
                  <validated-section :errors="errors" field="applicant_race">
                    <select v-model="applicant.race_id" required
                            class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.races" :value="item.id">{{ item.race_desc }}</option>
                    </select>
                  </validated-section>
                </div>
                <ul v-if="usingScreenReader" aria-label="Explanation from the Ethnicity" class="uk-width-1-1">
                  <li>Hispanic or Latino: A person of Cuban, Mexican, Puerto Rican, South or Central American, or other
                    Spanish culture or origin, regardless of race. The term “Spanish origin” can be used in addition to
                    “Hispanic” or “Latino.”
                  </li>
                  <li>Not Hispanic or Latino: A person not of Cuban, Mexican, Puerto Rican, South or Central American,
                    or
                    other Spanish culture or origin, regardless of race.
                  </li>
                </ul>
                <div class="uk-width-medium-1-4 uk-margin-bottom">
                  <label>{{ __('tenant.ethnicity') }}:<a uk-tooltip title="EXPLANATION FROM THE ENTHENTICITY"
                                                         onclick="UIkit.modal.alert('<div class=\'uk-grid\'><div class=\'uk-width-1-1 uk-margin-bottom\'><h1>Explanation from the Ethnicity</h1></div><div class=\'uk-width-1-1\'><ul><li><strong>Hispanic or Latino: </strong>A person of Cuban, Mexican, Puerto Rican, South or Central American, or other Spanish culture or origin, regardless of race. The term “Spanish origin” can be used in addition to “Hispanic” or “Latino.”</li><li><strong>Not Hispanic or Latino: </strong>A person not of Cuban, Mexican, Puerto Rican, South or Central American, or other Spanish culture or origin, regardless of race.</li> </ul></div></div>');"
                                                         class="uk-dark uk-light use-hand-cursor theme-primary-bg-color"
                                                         style="top: -55px; float: right; margin-right: 5.85px; padding: 0px; font-size: 14px; background-color: #6495d1; width: 20px; height: 20px; display: block; border-radius: 10px; text-align: center; color:white">?</a></label>
                  <validated-section :errors="errors" field="applicant_ethnicity">
                    <select v-model="applicant.ethnicity_id" required
                            class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.ethnicities" :value="item.id">{{ item.ethnicity_desc }}</option>
                    </select>
                  </validated-section>
                </div>
                <div class="uk-width-medium-1-4 uk-margin-bottom">
                  <label>{{ __('tenant.gender') }}:</label>
                  <validated-section :errors="errors" field="applicant_sex">
                    <select :aria-label="__('tenant.gender')" v-model="applicant.sex_id" required
                            class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.genders" :value="item.id">{{ item.gender_desc }}</option>
                    </select>
                  </validated-section>
                </div>
                <div class="uk-width-medium-1-4 uk-margin-bottom">
                  <label>{{ __('tenant.work_status') }}:</label>
                  <validated-section :errors="errors" field="applicant_work_status">
                    <select v-model="applicant.work_id" required
                            class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.workStatus" :value="item.id">{{ item.work_status_desc }}</option>
                    </select>
                  </validated-section>
                </div>
                <div class="uk-width-medium-1-4 uk-margin-bottom">
                  <label>{{ __('tenant.how_many_in_hh') }}:</label>
                  <validated-section :errors="errors" field="applicant_household_size">
                    <select v-model="applicant.household_size_id" required
                            class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.householdSize" v-if="item.household_size > 1" :value="item.id">
                        {{ item.household_size_description }}
                      </option>
                    </select>
                  </validated-section>
                  <small v-if="application.program.slug === 'mrap'">To determine household size click <a uk-tooltip
                                                                                                         title="HOW TO CALCULATE HOUSEHOLD SIZE"
                                                                                                         onclick="UIkit.modal.alert('<div class=\'uk-grid\'> <div class=\'uk-width-1-1 uk-margin-bottom\'> <h1>Calculating Household Size</h1> <p>Household members includes all adults and children living in the unit, including the following:</p> <ul> <li>Children temporarily absent due to placement in a foster home</li> <li>Children in joint custody who live in unit at least 50% of the time</li> <li>Children away at school but live with the family during recess</li> <li>Unborn children of pregnant women</li> <li>Children in the process of being adopted</li> <li>Temporarily absent family members who are still considered family members</li> <li>Family members in the hospital or rehab facility for limited or fixed time</li> <li>Persons permanently confined to a hospital or nursing home.</li> </ul> <p>Household members do not include:</p> <ul> <li>Live-in aides</li> <li>Guests</li> <li>Individuals in the same residence that have a separate lease obligation</li></ul> </div></div>');">HERE</a>.</small>
                </div>
                <div class="uk-width-medium-1-4 uk-margin-bottom">
                  <label>{{ __('tenant.referral_source') }}:</label>
                  <validated-section :errors="errors" field="referral_source">
                    <select v-model="application.referral_source_id" required
                            class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.referralSources" :value="item.id">
                        {{ item.referral_source_name }}
                      </option>
                      <option value="-1">Other...</option>
                    </select>
                  </validated-section>
                </div>
                <div class="uk-width-medium-1-4" v-if="application.referral_source_id == -1">
                  <validated-section :errors="errors" field="referral_source_other">
                    <label>Other Referral Source:</label>
                    <input name="referral_source_other" type="text" placeholder="Referral Source Name"
                           class="uk-width-1-1 uk-margin-bottom uk-form-large" v-model="application.referral_source_other">
                  </validated-section>
                </div>

                <div class="uk-width-medium-1-1">
                  <validated-section :errors="errors" field="application.jobs_data.tanf_eligible">
                    <label class="uk-margin-small-bottom">{{ __('tenant.tanf_eligible', { fee: 250, program_name: 'WRTU'}) }}</label>
                    <br/>
                    <label class="uk-display-inline uk-margin-right">
                      <input type="radio" name="tanf_eligible" value="1" v-model="application.jobs_data.tanf_eligible">
                      Yes
                    </label>
                    <label class="uk-display-inline">
                      <input type="radio" name="tanf_eligible" value="0" v-model="application.jobs_data.tanf_eligible">
                      No
                    </label>
                  </validated-section>
                </div>
              </div>
              <div class="uk-grid">
                <div class="uk-width-medium-1-2 uk-width-small-1-1">
                  <validated-section :errors="errors" field="applicant_ssn">
                    <label>{{ ssnLabel }}:</label>
                    <input name="pa_ssn" v-mask="'###-##-####'" pattern="[0-9]{9}" type="text" :placeholder="ssnLabel"
                           class="uk-width-1-1 uk-margin-bottom uk-form-large" v-model="applicant.ssn"
                           :disabled="lockSSN">
                  </validated-section>
                  <div v-if="showHhmIdSsnCheckbox" class="uk-margin uk-grid-small uk-child-width-auto uk-grid">
                    <label><input v-model="applicant.use_hhmid_as_ssn" class="uk-checkbox" type="checkbox"> Use my
                      unique
                      ID number on this site as my SSN</label>
                  </div>

                </div>
                <div class="uk-width-medium-1-4 uk-width-small-1-1" v-if="programSettings['use-itin']">
                  <label>{{ __('tenant.itin') }}:</label>
                  <input name="pa_itin" v-mask="'###-##-####'" pattern="[0-9]{9}" type="text"
                         :placeholder="__('tenant.itin')" class="uk-width-1-1 uk-margin-bottom uk-form-large"
                         v-model="applicant.itin">
                </div>
              </div>
            </div>
            <hr class="uk-grid-divider uk-margin-bottom uk-margin-top app-fades" style="border:none;">
            <legend class="app-fades">{{ __('tenant.primary_contact_info') }}</legend>
            <div class="uk-container">
              <div class="uk-grid" data-uk-margin>
                <div class="uk-width-medium-5-10 uk-margin-bottom">
                  <phone-number-input :name="__('tenant.primary_phone')"
                                      v-model="applicant.primary_contact.formatted_number"
                                      :label="__('tenant.primary_phone')"
                                      rules="required"/>
                </div>
                <div class="uk-width-medium-5-10 uk-margin-bottom">
                  <phone-number-input :name="__('tenant.secondary_phone')"
                                      v-model="applicant.secondary_contact.formatted_number"
                                      :label="__('tenant.secondary_phone')"/>
                </div>
              </div>

              <label v-if="programSettings['confidential-address-program']">
                <input type="checkbox" name="confidential_address_program"
                       v-model="applicant.confidential_address_program">
                {{ __('tenant.confidential_address_program_desc') }}
                <br/><br/>
              </label>

              <div class="uk-form-row uk-margin-bottom">
                <p class="uk-margin-bottom-remove"><small>&nbsp;{{ __('tenant.property_address') }}:</small></p>
                <div class="uk-grid">
                  <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1 uk-margin-small-top">
                    <label>{{ __('tenant.property_address_line_1') }}</label>
                    <TextInput v-model="applicant.property_address.line_1" name="Line1" placeholder="Street Address"
                               rules="required" :disabled="isHomeless"/>
                  </div>
                  <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1 uk-margin-small-top">
                    <label>{{ __('tenant.property_address_line_2') }}</label>
                    <TextInput v-model="applicant.property_address.line_2" name="Line2" placeholder="Unit"
                               :disabled="isHomeless"/>
                  </div>
                  <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                    <label>{{ __('tenant.property_address_city') }}</label>
                    <TextInput v-model="applicant.property_address.city" name="City" placeholder="City" rules="required"
                               :disabled="isHomeless"/>
                  </div>
                  <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                    <label>{{ __('tenant.property_address_state') }}</label>
                    <select v-model="applicant.property_address.state_id"
                            class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large"
                            :disabled="isHomeless">
                      <option :value="null" selected>_</option>
                      <option v-for="item in assets.states" :value="item.id" :key="item.id">{{
                          item.state_name
                        }}
                      </option>
                    </select>
                  </div>
                  <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                    <label>{{ __('tenant.property_address_zip') }}</label>
                    <TextInput v-model="applicant.property_address.zip" name="Zip" placeholder="Zip" rules="required"
                               :disabled="isHomeless"/>
                  </div>
                  <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                    <label>{{ __('tenant.property_address_county') }}</label>
                    <select :aria-label="__('tenant.property_address_county')"
                            v-model="applicant.property_address.county_id"
                            class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                      <option :value="null" selected>_</option>
                      <option v-for="item in filteredCounties" :value="item.id" :key="item.id">{{ item.county_name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <br/><br/>
              <label>
                <input type="checkbox" name="is_mail_address_same" onChange="$('#mailing-address').slideToggle();"
                       class="" v-model="applicant.is_mail_address_same">
                {{ __('tenant.primary_mail_same') }}</label>
              <div id="mailing-address" class="uk-form-row uk-margin-top" v-if="!applicant.is_mail_address_same">
                <div class="uk-margin-large-bottom"><small>&nbsp;{{ __('tenant.primary_mail_address') }}:</small></div>
                <div class="uk-grid">
                  <div class="uk-width-3-5 uk-width-medium-1-2 uk-width-small-1-1 uk-margin-small-top">
                    <label>{{ __('tenant.mailing_address_line_1') }}</label>
                    <TextInput v-model="applicant.mail_address.line_1" name="Line1" placeholder="Street Address"
                               rules="required"/>
                  </div>
                  <div class="uk-width-3-5 uk-width-medium-1-2 uk-width-small-1-1 uk-margin-small-top">
                    <label>{{ __('tenant.mailing_address_line_2') }}</label>
                    <TextInput v-model="applicant.mail_address.line_2" name="Line2" placeholder="Unit"/>
                  </div>
                  <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                    <label>{{ __('tenant.mailing_address_city') }}</label>
                    <TextInput v-model="applicant.mail_address.city" name="City" placeholder="City" rules="required"/>
                  </div>
                  <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                    <label>{{ __('tenant.mailing_address_state') }}</label>
                    <validated-section :errors="errors" field="applicant_mail_address_state">
                      <select v-model="applicant.mail_address.state_id"
                              class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                        <option :value="null" selected>_</option>
                        <option v-for="item in assets.states" :value="item.id" :key="item.id">{{ item.state_name }}
                        </option>
                      </select>
                    </validated-section>
                  </div>
                  <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                    <label>{{ __('tenant.mailing_address_zip') }}</label>
                    <TextInput v-model="applicant.mail_address.zip" name="Zip" placeholder="Zip" rules="required"/>
                  </div>
                </div>
              </div>
            </div>
            <br/><br/>
          </template>
          <!-- APPEND ADDITIONAL APPLICANTS HERE -->
          <div class="students-wrapper" v-if="student">
            <div v-for="(member, index) in hhMembers" :key="index" class="household-memeber-form clonedInput">
              <legend class="app-fades">{{
                  index === 0 ? __('tenant.student') : __('tenant.household_member') + ' ' +
                      index
                }}
              </legend>
              <br/><br/>
              <div class="uk-container ">
                <div class="uk-grid">
                  <div class="uk-width-small-1-1 uk-width-medium-1-2 uk-margin-bottom">
                    <date-picker :name="__('tenant.birth_date')" :label="__('tenant.birth_date')"
                                 v-model="member.birth_date" :config="datePickerConfig"
                                 :placeholder="__('tenant.birth_date')"
                                 rules="required"/>
                  </div>

                  <div class="uk-width-small-1-1 uk-width-medium-1-2 uk-margin-bottom">
                    <label>{{ __('tenant.relationship_parent') }}:</label>
                    <validated-section :errors="errors" :field="`member_${index}_relationship`">
                      <select v-if="index === 0" :aria-label="__('tenant.relationship_parent')"
                              v-model="member.relationship_to_hh_id"
                              class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                        <option>_</option>
                        <option v-for="item in assets.parentRelationships" :key="item.id" :value="item.id">{{
                            item.label
                          }}
                        </option>
                      </select>
                      <select v-else :aria-label="__('tenant.relationship_parent')"
                              v-model="member.relationship_to_hh_id"
                              class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                        <option>_</option>
                        <option v-for="item in assets.hhRelations" :key="item.id" :value="item.id">{{
                            item.household_relationship_desc
                          }}
                        </option>
                      </select>
                    </validated-section>
                  </div>

                  <div v-if="index === 0" class="uk-width-small-1-2 uk-width-medium-1-2 uk-margin-bottom">
                    <label>{{ __('tenant.grade') }}:</label>
                    <validated-section :errors="errors" :field="`member_${index}_grade`">
                      <select :aria-label="__('tenant.grade')" v-model="member.grade_id"
                              class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                        <option>_</option>
                        <option v-for="item in assets.grades" :key="item.id" :value="item.id">{{
                            item.label
                          }}
                        </option>
                      </select>
                    </validated-section>
                  </div>
                  <div v-if="index === 0" class="uk-width-small-1-2 uk-width-medium-1-2 uk-margin-bottom">
                    <label>{{ __('tenant.next_grade') }}:</label>
                    <validated-section :errors="errors" :field="`member_${index}_next_grade`">
                      <select :aria-label="__('tenant.next_grade')" v-model="member.next_grade_id"
                              class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                        <option>_</option>
                        <option v-for="item in assets.grades" :key="item.id" :value="item.id">{{
                            item.label
                          }}
                        </option>
                      </select>
                    </validated-section>
                  </div>

                </div>
                <div class="uk-grid">
                  <div class="uk-width-medium-1-2 uk-margin-bottom">
                    <TextInput v-model="member.first_name" :name="__('tenant.first_name')"
                               :placeholder="__('tenant.first_name')" :label="__('tenant.first_name')"
                               :disabled="(programSettings['hide-minor-household-member-names'] && _getAge(member.birth_date) < 18)"
                               rules="required"/>
                  </div>
                  <div class="uk-width-medium-1-2 uk-margin-bottom">
                    <TextInput v-model="member.last_name" :name="__('tenant.last_name')"
                               :placeholder="__('tenant.last_name')" :label="__('tenant.last_name')"
                               :disabled="(programSettings['hide-minor-household-member-names'] && _getAge(member.birth_date) < 18)"
                               rules="required"/>
                  </div>
                  <div class="uk-width-medium-1-2 uk-margin-bottom">
                    <TextInput v-model="member.preferred_name" :name="__('tenant.preferred_name')"
                               :placeholder="__('tenant.preferred_name')" :label="__('tenant.preferred_name')"
                               :disabled="(programSettings['hide-minor-household-member-names'] && _getAge(member.birth_date) < 18)"
                               rules="required"/>
                  </div>
                  <div class="uk-width-medium-1-2 uk-margin-bottom">
                    <validated-section :errors="errors" :field="`member_${index}_pronouns`">
                      <label>{{ __('tenant.pronouns') }}:</label>
                      <select :aria-label="__('tenant.pronouns')" v-model="member.pronoun_key" required
                              class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                        <option :value="null" selected>_</option>
                        <option v-for="item in assets.pronouns" :value="item.value">{{ item.body }}</option>
                      </select>
                    </validated-section>
                  </div>
                </div>
                <div v-if="index === 0" class="uk-grid">
                  <div class="uk-width-medium-1-2 uk-margin-bottom">
                    <validated-section :errors="errors" :fields="[`member_${index}_email`, `hhMembers.${index}.email`]">
                      <TextInput v-model="member.email" :name="__('global.email')" :placeholder="__('global.email')"
                                 :label="__('global.email')" rules="required"/>
                    </validated-section>
                  </div>
                  <div class="uk-width-medium-1-2 uk-margin-bottom">
                    <validated-section :errors="errors" :field="`member_${index}_phone`">
                      <phone-number-input :name="__('global.phone')" v-model="member.primaryPhone"
                                          :label="__('global.phone')"/>
                    </validated-section>
                  </div>
                </div>
                <div v-if="index === 0" class="uk-grid">
                  <div class="uk-width-medium-1-4 uk-margin-bottom"
                       v-if="programSettings['show-household-member-social']">
                    <validated-section :errors="serverValidationErrors"
                                       :field="`hhMembers.${index}.social_security_number`">
                      <label>{{ ssnLabel }}:</label>
                      <input name="pa_ssn" v-mask="'###-##-####'" pattern="[0-9]{9}" type="text" :placeholder="ssnLabel"
                             class="uk-width-1-1 uk-margin-bottom uk-form-large" v-model="member.social_security_number"
                             :disabled="lockSSN">
                    </validated-section>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['show-hhm-demographics']">
                    <label>{{ __('tenant.race') }}:</label>
                    <validated-section :errors="errors" :field="`member_${index}_race`">
                      <select :aria-label="__('tenant.race')" v-model="member.race_id" required
                              class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                        <option :value="null" selected>_</option>
                        <option v-for="item in assets.races" :value="item.id">{{ item.race_desc }}</option>
                      </select>
                    </validated-section>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['show-hhm-demographics']">
                    <label>{{ __('tenant.ethnicity') }}:</label>
                    <validated-section :errors="errors" :field="`member_${index}_ethnicity`">
                      <select :aria-label="__('tenant.ethnicity')" v-model="member.ethnicity_id" required
                              class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                        <option :value="null" selected>_</option>
                        <option v-for="item in assets.ethnicities" :value="item.id">{{ item.ethnicity_desc }}</option>
                      </select>
                    </validated-section>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['show-hhm-demographics']">
                    <label>{{ __('tenant.gender') }}:</label>
                    <validated-section :errors="errors" :field="`member_${index}_gender`">
                      <select :aria-label="__('tenant.gender')" v-model="member.gender_id" required
                              class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                        <option :value="null" selected>_</option>
                        <option v-for="item in assets.genders" :value="item.id">{{ item.gender_desc }}</option>
                      </select>
                    </validated-section>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['show-hhm-demographics']">
                    <label>{{ __('tenant.primary_language') }}:</label>
                    <validated-section :errors="errors" :field="`member_${index}_primary_language`">
                      <select :aria-label="__('tenant.primary_language')" v-model="member.primary_language_id" required
                              class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                        <option :value="null" selected>_</option>
                        <option v-for="item in assets.languages" :value="item.id">{{ item.language_desc }}</option>
                      </select>
                    </validated-section>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>{{ __('tenant.country_origin') }}:</label>
                    <validated-section :errors="errors" :field="`member_${index}_country_id`">
                      <select :aria-label="__('tenant.country_origin')" v-model="member.country_id" required
                              class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                        <option :value="null" selected>_</option>
                        <option v-for="item in assets.countries" :value="item.id">{{ item.label }}</option>
                      </select>
                    </validated-section>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>{{ __('tenant.resident_status') }}:</label>
                    <validated-section :errors="errors" :field="`member_${index}_resident_status_id`">
                      <select :aria-label="__('tenant.resident_status')" v-model="member.resident_status_id" required
                              class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                        <option :value="null" selected>_</option>
                        <option v-for="item in assets.residentStatus" :value="item.id">{{ item.label }}</option>
                      </select>
                    </validated-section>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <validated-section :errors="errors" :field="`member_${index}_tshirt_size_id`">
                      <label>School Attending</label>
                      <div v-if="member.school_attending">
                        <strong>{{ member.school_attending }}</strong>
                        <button @click="setSchool()" type="button" class="uk-button uk-button-small">Change</button>
                      </div>
                      <autocomplete v-else placeholder="Find School..." ref="autocomplete" class="form-autocomplete"
                                    :search="search" :debounce-time="200" :get-result-value="getResultValue"
                                    @submit="setSchool">
                      </autocomplete>
                    </validated-section>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>{{ __('tenant.tshirt_size') }}:</label>
                    <validated-section :errors="errors" :field="`member_${index}_tshirt_size_id`">
                      <select :aria-label="__('tenant.tshirt_size')" v-model="member.tshirt_size_id" required
                              class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                        <option :value="null" selected>_</option>
                        <option v-for="item in assets.tshirtSize" :value="item.id">{{ item.label }}</option>
                      </select>
                    </validated-section>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label>{{ __('tenant.access_transportation') }}:</label>
                    <validated-section :errors="errors" :field="`member_${index}_access_transportation`">
                      <select :aria-label="__('tenant.access_transportation')" v-model="member.access_transportation"
                              required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                        <option :value="null" selected>_</option>
                        <option :value="1">{{ __('tenant.access_transportation_yes') }}</option>
                        <option :value="0">{{ __('tenant.access_transportation_no') }}</option>
                      </select>
                    </validated-section>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <TextInput type="number" v-model="member.student_id_number" :name="__('tenant.student_id_number')"
                               :placeholder="__('tenant.student_id_number')" :label="__('tenant.student_id_number')"/>
                  </div>
                  <div class="uk-width-medium-1-1 uk-margin-bottom">
                    <validated-section :errors="errors" :field="`member_${index}_career_path_interest`">
                      <label>{{ __('tenant.career_path_interest') }}</label>
                      <div class="uk-width-1-1 uk-margin-top" v-for="interest in programInterests">
                        <label :for="`e_career_interest_${interest.id}`" class="use-hand-cursor">
                          <input type="checkbox" v-model="member.career_path_interest" :value="interest.id"
                                 :id="`e_career_interest_${interest.id}`" class="uk-checkbox"/>
                          {{ interest.label }}
                        </label>
                      </div>
                    </validated-section>
                  </div>
                </div>
                <div v-if="index === 0" class="uk-grid">
                  <div class="uk-width-medium-1-2 uk-margin-large-bottom">
                    <CustomTextarea :rows="3" name="CareerInterest" :label="__('tenant.specify_career_interest')"
                                    v-model="member.career_interests" rules="required"/>
                  </div>
                  <div class="uk-width-medium-1-2 uk-margin-large-bottom">
                    <label>Has the student been involved in any other Columbus Urban League programs? (If yes, please
                      list the names of those programs)</label>
                    <div class="uk-margin-top">
                      <validated-section :errors="errors" field="has_other_program">
                        <label class="uk-display-inline"><input type="radio" name="has_other_program" value="1"
                                                                v-model="member.has_other_program"> Yes</label>
                        <label class="uk-display-inline uk-margin-left"><input type="radio" name="has_other_program"
                                                                               value="0"
                                                                               v-model="member.has_other_program">
                          No</label>
                      </validated-section>
                    </div>
                    <div class="uk-margin-top" v-if="(member.has_other_program == 1)">
                      <CustomTextarea :rows="3" name="OtherProgram" v-model="member.other_program" rules="required"/>
                    </div>
                  </div>
                  <div class="uk-width-medium-1-2 uk-margin-bottom">
                    <label>{{ __('tenant.e_primary_plan') }}:</label>
                    <validated-section :errors="errors" :field="`member_${index}_primary_plan`">
                      <div class="uk-grid">
                        <div v-for="(item, index1) in assets.educationPrimaryPlans" :key="index1"
                             class="uk-width-1-1 uk-margin-top">
                          <label :for="`e_primary_plan_` + index + '_' + index1" class="use-hand-cursor">
                            <input type="checkbox" v-model="member.primary_plans" :value="item.id"
                                   :id="`e_primary_plan_` + index + '_' + index1" class="uk-checkbox"/>
                            {{ item.label }}
                          </label>
                        </div>
                      </div>
                    </validated-section>
                  </div>
                  <div class="uk-width-medium-1-2 uk-margin-bottom">
                    <label>{{ __('tenant.youth_have_access') }}:</label>
                    <validated-section :errors="errors" :field="`member_${index}_youth_access_type`">
                      <div class="uk-grid">
                        <div v-for="(item, index1) in assets.youthAccessTypes" :key="index1"
                             class="uk-width-1-1 uk-margin-top">
                          <label :for="`youth_access_type_` + index + '_' + index1" class="use-hand-cursor">
                            <input type="checkbox" v-model="member.connectivity_access" :value="item.id"
                                   :id="`youth_access_type_` + index + '_' + index1" class="uk-checkbox"/>
                            {{ item.label }}
                          </label>
                        </div>
                      </div>
                    </validated-section>
                  </div>
                  <br/>
                  <div class="uk-width-medium-1-1 uk-margin-top uk-margin-large-bottom">
                    <p>{{ __('tenant.apply_multiple_children') }}</p>
                  </div>
                </div>
                <div>
                  <a v-if="member.household_member_key != '2'"
                     class="uk-button uk-button-mini uk-width-1-1 uk-width-medium-1-3 uk-push-2-3 uk-margin-top"
                     @click="removeHHMember(index);"><i class="uk-icon-times"></i>{{ __('tenant.remove_member') }}</a>
                </div>
              </div>
            </div>
          </div>
          <hr class="uk-grid-divider uk-margin-bottom uk-margin-top app-fades">
          <p id="AdditionalQualifyingApplicantQuestion" class="uk-text-center">{{
              __('tenant.is_another_hh_member')
            }}<br/></p>
          <div class="uk-grid uk-margin-large-bottom">

            <div class="uk-width-1-1 uk-text-center">
              <a class="uk-button uk-width-small-1-1 uk-width-medium-1-3" @click="addHHMember()"><i
                  class="uk-icon-plus-square-o" id="ApplicantYes"></i> {{ __('tenant.add_member') }} </a>
            </div>

          </div>
        </fieldset>
      </form>
    </ValidationObserver>

    <create-school-modal ref="schoolModal" @updated="setSchool"></create-school-modal>
  </div>
</template>

<script>
import {mapGetters, mapState, mapMutations} from 'vuex';
// import moment from 'moment'
import ValidatedSection from "./../../../../../../../components/Common/ValidatedSection";
import Autocomplete from '@trevoreyre/autocomplete-vue';
import CreateSchoolModal from "../../../../../../../components/AppWizard/CreateSchoolModal";

export default {
  name: "Step1",
  props: {
    print: {
      type: Boolean,
      default: false,
    }
  },
  components: {CreateSchoolModal, ValidatedSection, Autocomplete},
  data() {
    return {
      errors: {},
      loading: false,
      serverValidationErrors: {},

      applicantDatePickerConfig: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        maxDate: moment().subtract(18, 'years').toDate(),
      },
      datePickerConfig: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
      },
      submitData: {
        projectName: '',
        isSameManager: true,
      },
      primaryResidenceToggle: null,
    }
  },

  mounted() {
    if (this.application) {
      if (!this.application.jobs_data)
        this.application.jobs_data = {
          applicant_type: null,
        }
      this.submitData.projectName = this.application.project_name
      this.submitData.isSameManager = this.application.is_renter_same_manager

      if (this.application.is_vacated && this.programSettings['uses-vacated-status']) {
        this.primaryResidenceToggle = 'vacated';
      } else if (this.application.is_homeless && this.programSettings['uses-homeless-application']) {
        this.primaryResidenceToggle = 'homeless';
      } else if (this.applicant.is_primary_residence) {
        this.primaryResidenceToggle = 'property';
      }

      if (!this.hhMembers.length) {
        this.addStudent();
      }
    }
  },

  watch: {
    'application': {
      handler: function (newValue, oldValue) {
        if (newValue) {
          this.submitData.projectName = newValue.project_name
          this.submitData.isSameManager = newValue.is_renter_same_manager
        }
      },
      deep: true,
    },
    'applicant.household_size_id': {
      handler: function (newValue, oldValue) {
        if (newValue) {
          const hhSizeItem = this.assets.householdSize.find(item => item.id == newValue)
          let data = this.hhMembers.filter(item => item.first_name || item.last_name)
          if (hhSizeItem.household_size_key > data.length) {
            data = data.concat(Array.from({length: hhSizeItem.household_size_key - data.length - 1}, (x, i) => {
              return {type: 2}
            }))
          }
          this.$store.dispatch('Application/updateHHMember', data)
        }
      },
    },

    'loading': {
      handler: function (newValue, oldValue) {
        this.$isLoading(newValue)
      },
    },
    'primaryResidenceToggle': {
      handler: function (newValue, oldValue) {
        if (oldValue && newValue != oldValue && newValue == 'homeless') {
          UIkit.modal.confirm(this.__(`tenant.homeless_alert`))
              .then((res) => {
                this.setAppHomeless();
              })
              .catch(() => {
                this.primaryResidenceToggle = oldValue
              });
        }
      }
    }
  },

  computed: {
    lockSSN() {
      return this.programSettings['use-hhm-id-as-ssn'] && !!this.applicant.use_hhmid_as_ssn
    },

    showHhmIdSsnCheckbox() {
      return this.programSettings['use-hhm-id-as-ssn'] &&
          (
              !this.programSettings['require-applicant-social-security-number'] ||
              this.programSettings['require-applicant-social-security-number'] && this.errors['applicant_ssn']
          )
    },

    showPropertyAsOptions() {
      return this.programSettings['uses-vacated-status'] || this.programSettings['uses-homeless-application']
    },
    isHomeless() {
      return this.programSettings['uses-homeless-application'] && this.primaryResidenceToggle === 'homeless'
    },

    ssnLabel() {
      let result = ''
      if (this.programSettings['use-itin']) {
        result = this.__(`tenant.itin`)
      } else {
        result = this.__(`tenant.ssn_full`)
      }
      if (!this.programSettings['require-applicant-social-security-number']) {
        result += " (NOT REQUIRED) "
      }
      return result
    },

    user() {
      return this.$store.getters['App/user']
    },
    filteredCounties() {
      if (this.applicant.property_address.state_id) {
        return _.filter(this.assets.counties, county => {
          return county.state_id === this.applicant.property_address.state_id;
        })
      }
      return [];
    },
    programInterests() {
      return this.assets.careerFieldInterests.filter(interest => interest.program_id == this.application.program_id);
    },
    ...mapState('Application', {
      assets: 'assets',
      application: 'application',
      program: state => state.application.program,
      applicant: 'applicant',
      hhMembers: 'hhMembers',
      renterManager: 'renterManager',
      renterOwner: 'renterOwner',
      organization: 'organization',
      userIsStudent: 'userIsStudent',
    }),
    ...mapGetters('Application', ['programSettings', 'defaultProject', 'student']),
  },

  methods: {
    setLoading(val) {
      this.loading = val
    },

    removeHHMember(index) {
      this.$store.dispatch('Application/removeHHMember', index)
    },
    addHHMember() {
      this.$store.dispatch('Application/addHHMember')
    },

    setAppHomeless() {
      this.applicant.property_address = this.defaultProject.address
    },

    addStudent() {
      this.$store.dispatch('Application/addStudent')
    },

    updatePropertyAddress(propertyResult) {
      this.applicant.property_address.line_1 = propertyResult.address.line_1;
      this.applicant.property_address.city = propertyResult.address.city;
      this.applicant.property_address.state = propertyResult.address.state;
      this.applicant.property_address.state_id = propertyResult.address.state_id;
      this.applicant.property_address.zip = propertyResult.address.zip;
    },

    getResultValue(result) {
      return result.organization_name;
    },
    async search(queryString) {
      if (queryString.length < 3) return [];
      let url = '/api/hope/jobs/schools';
      let r = await axios.get(url + '?query=' + queryString)
      r.data.push({
        id: null,
        organization_name: 'Add New School',
      })
      return r.data;
    },

    timeout(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async setSchool(result) {
      if (result && result.id) {
        // Set School
        this.$refs.autocomplete.value = result.organization_name;
        this.hhMembers[0].school_attending = result.organization_name;
        this.hhMembers[0].school_organization_id = result.id;
      } else if (result && result.id === null) {
        // Clear and open modal
        this.hhMembers[0].school_attending = null;
        this.hhMembers[0].school_organization_id = null;
        this.$refs.schoolModal.open(this.application.id);
      } else {
        // Just clear
        this.hhMembers[0].school_attending = null;
        this.hhMembers[0].school_organization_id = null;
      }

    },

    scrollToErrorField() {
      const errors = Object.entries(this.$refs.applicantForm.errors)
          .map(([key, value]) => ({key, value}))
          .filter(error => error["value"].length);
      if (errors && errors.length) {
        this.$refs.applicantForm.refs[errors[0]["key"]].$el.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      } else {
        this.scrollTop();
      }
    },

    scrollTop: function () {
      if (window.pageYOffset > 0) {
        this.intervalId = setInterval(() => {
          if (window.pageYOffset === 0) {
            clearInterval(this.intervalId)
          }
          window.scroll(0, window.pageYOffset - 50)
        }, 5)
      }
    },

    _getAge(birthday) {
      let dob = moment(birthday);
      let now = moment();
      return Math.abs(now.diff(dob, 'years'));
    },

    async validateStep() {
      this.errors = {}
      let stepValid = false;

      let customValid = true;

      if (!this.userIsStudent) {
        if (this.programSettings['demographics-required-applicant']) {
          if (this.applicant.race_id == undefined) {
            this.errors['applicant_race'] = {errors: [this.__('validation.must_select_option')]};
          }
          if (this.applicant.ethnicity_id == undefined) {
            this.errors['applicant_ethnicity'] = {errors: [this.__('validation.must_select_option')]};
          }
          if (this.applicant.sex_id == undefined) {
            this.errors['applicant_sex'] = {errors: [this.__('validation.must_select_option')]};
          }
          if (this.applicant.work_id == undefined && this.programSettings['uses-work-status']) {
            this.errors['applicant_work_status'] = {errors: [this.__('validation.must_select_option')]};
          }
        }

        if (this.application.jobs_data.applicant_type == null) {
          this.errors[`applicant_type`] = {errors: [this.__('validation.must_select_option')]};
        }

        if (this.programSettings['require-applicant-social-security-number'] && !this.applicant.ssn) {
          if (!this.programSettings['use-hhm-id-as-ssn'] || !this.applicant.use_hhmid_as_ssn) {
            this.errors['applicant_ssn'] = {errors: ['This field is required.']};
          }
        }

        if (!this.applicant.is_mail_address_same && this.applicant.mail_address && this.applicant.mail_address.state_id == null) {
          this.errors['applicant_mail_address_state'] = {errors: [this.__('validation.must_select_option')]};
        }
      }

      if(!this.application.jobs_data.tanf_eligible) {
        // this.errors['application.jobs_data.tanf_eligible'] = {errors: ['You must accept the TANF Eligibility Statement to continue.']};
      }

      for (var index in this.hhMembers) {
        let member = this.hhMembers[index];
        if (member.relationship_to_hh_id == undefined) {
          this.errors[`member_${index}_relationship`] = {errors: [this.__('validation.must_select_option')]};
        }
        if (index == 0) {
          if (!member.primary_plans || !member.primary_plans.length) {
            this.errors[`member_${index}_primary_plan`] = {errors: [this.__('validation.must_select_option')]};
          }
          if (member.grade_id == undefined) {
            this.errors[`member_${index}_grade`] = {errors: [this.__('validation.must_select_option')]};
          }
          if (member.next_grade_id == undefined) {
            this.errors[`member_${index}_next_grade`] = {errors: [this.__('validation.must_select_option')]};
          }
          if (this.programSettings['show-hhm-demographics'] && this.programSettings['demographics-required-member']) {
            if (member.race_id == undefined) {
              this.errors[`member_${index}_race`] = {errors: [this.__('validation.must_select_option')]};
            }
            if (member.ethnicity_id == undefined) {
              this.errors[`member_${index}_ethnicity`] = {errors: [this.__('validation.must_select_option')]};
            }
            if (member.gender_id == undefined) {
              this.errors[`member_${index}_gender`] = {errors: [this.__('validation.must_select_option')]};
            }
            if (member.primary_language_id == undefined) {
              this.errors[`member_${index}_primary_language`] = {errors: [this.__('validation.must_select_option')]};
            }
          }
          if (member.country_id == undefined) {
            this.errors[`member_${index}_country_id`] = {errors: [this.__('validation.must_select_option')]};
          }
          if (member.resident_status_id == undefined) {
            this.errors[`member_${index}_resident_status_id`] = {errors: [this.__('validation.must_select_option')]};
          }
          if (member.tshirt_size_id == undefined) {
            this.errors[`member_${index}_tshirt_size_id`] = {errors: [this.__('validation.must_select_option')]};
          }
          if (member.access_transportation == undefined) {
            this.errors[`member_${index}_access_transportation`] = {errors: [this.__('validation.must_select_option')]};
          }
          if (member.career_path_interest == undefined) {
            this.errors[`member_${index}_career_path_interest`] = {errors: [this.__('validation.must_select_option')]};
          }else  if (member.career_path_interest.length > 3) {
            this.errors[`member_${index}_career_path_interest`] = {
              errors: [this.__('validation.max.numeric', {
                'attribute': 'Career Path Interest Selections',
                'max': 3
              })]
            };
          }
        }
      }

      // Check to make sure the applicant email is not the same as the student email
      if (this.application.user.email === this.hhMembers[0].email) {
        this.errors['member_0_email'] = {errors: ['Student Email Address Cannot Match Parent/Guardian Email Address']};
      }

      if (_.size(this.errors) == 0) {
        await this.$refs.applicantForm.validate().then(async (isValid) => {
          if (isValid) {
            if (customValid == true) {
              stepValid = await this.submitForm()
            }

          }
        })
      }

      if (_.size(this.errors) > 0) stepValid = false;

      if (!stepValid) {
        setTimeout(() => {
          this.scrollToErrorField()
        }, 10);
      }

      return stepValid
    },

    async submitForm() {
      let stepValid = false
      this.$emit('loading', true)

      const payload = {
        ...this.submitData,
        id: this.application.id,
        application: this.application,
        applicant: this.applicant,
        hhMembers: this.hhMembers,
        renterManager: this.renterManager,
        renterOwner: this.renterOwner,
        organization: this.organization,
        program_type: this.program.program_type,
      }

      await this.$store
          .dispatch(
              this.application && this.application.id ? 'Application/update' : 'Application/create',
              payload
          )
          .then((res) => {
            this.$emit('done', res)
            this.$emit('loading', false)
            stepValid = true
            this.$store.dispatch('Application/fetch', this.application.id);
            this.$store.dispatch('Application/fetchVendorList', this.application.id)
          })
          .catch((err) => {
            console.log(err.response);
            if (err.response.data.errors) {
              // this.$refs.createForm.setErrors(err.response.data.errors)
              this.errors = err.response.data.errors;
              this.serverValidationErrors = err.response.data.errors;
            }
            this.$emit('loading', false)
            stepValid = false
          })

      return stepValid
    },
  }
}
</script>

<style lang="scss">
.step1-wrapper {
  .autocomplete-input {
    width: 100% !important;
    height: 40px !important;
    padding: 8px 6px !important;
    font-size: 16px !important;
    border-radius: 0 !important;
    background-image: none !important;
  }

  .autocomplete-result-list {
    border-radius: 0 !important;
  }
}
</style>
